import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDiscipline extends TitleBase {
	private disciplineValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);

		return this.indexableFilters.length >= 1 && this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in ${this.disciplineValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.titlePortalType} in the field of ${this.disciplineValue}`, ' worldwide');
	}
}
